var React = require('react');

function ProductsIcon9Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Obszar_roboczy_15","data-name":"Obszar roboczy 15","transform":"translate(-4.71 -9.41)"},[React.createElement("path",{"id":"Path_280","data-name":"Path 280","d":"M4.71,15.4l5.93,15.19h2.84L7.54,15.4Z","key":0}),React.createElement("path",{"id":"Path_281","data-name":"Path 281","d":"M22.61,9.41,13.48,30.59h2.75L25.37,9.41Z","key":1}),React.createElement("path",{"id":"Path_282","data-name":"Path 282","d":"M27.55,9.41,18.42,30.59h2.76L30.31,9.41Z","key":2}),React.createElement("path",{"id":"Path_283","data-name":"Path 283","d":"M32.54,9.41,23.4,30.59h2.76L35.29,9.41Z","key":3})]));
}

ProductsIcon9Inline.defaultProps = {"width":"30.58","height":"21.18","viewBox":"0 0 30.58 21.18"};

module.exports = ProductsIcon9Inline;

ProductsIcon9Inline.default = ProductsIcon9Inline;
